import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';

export const StyledLoading = styled(CircularProgress)`
  svg {
    color: ${({ color }) => color};
  }
`;
